import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';
import { RouterHistoryService } from '~/core/services/router-history/router-history.service';

import { BackLinkVariantEnum } from './enums/back-link-variant.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-back-link',
  templateUrl: './back-link.component.html',
  styleUrls: ['./back-link.component.scss'],
})
export class BackLinkComponent {
  @Input() public ariaLabel: string;
  @Input() public backLink: BackLinkInterface;
  @Input() public enableHistoryNavigation: boolean;
  @Input() public variant = BackLinkVariantEnum.Default;

  public readonly backLinkIcon = VtmnPlayIconTypeEnum.ArrowLeft;

  constructor(
    private readonly router: Router,
    private readonly routerHistory: RouterHistoryService
  ) {}

  public get backLinkClass(): string {
    if (this.variant === BackLinkVariantEnum.White) {
      return 'back-link--white';
    }
    return '';
  }

  public get externalPath(): string | null {
    return this.backLink.path?.includes('http') ? this.backLink.path : null;
  }

  public get path(): string | null {
    return (
      (this.useHistory && this.routerHistory.previous?.split('?')[0]) ||
      this.backLink.path ||
      null
    );
  }

  public get queryParams(): { [key: string]: string } {
    if (this.useHistory) {
      const urlSearchParams = new URLSearchParams(
        this.routerHistory.previous.split('?')[1]
      );
      const queryParams = {};
      urlSearchParams.forEach((value, key) => (queryParams[key] = value));
      return queryParams;
    }
    return this.backLink.queryParams;
  }

  public get useHistory(): boolean {
    return this.enableHistoryNavigation && Boolean(this.routerHistory.previous);
  }

  public goBack(): void {
    this.router.navigateByUrl(this.routerHistory.previous);
  }
}
